import {
  BaseClass,
  IGraph,
  ILabel,
  ILabelModel,
  ILabelModelParameter,
  ILookup,
  INode,
  IOrientedRectangle,
  OrientedRectangle,
  Rect,
} from '@ardoq/yfiles';
import type { YGraphState } from '@ardoq/graph';
import { ensureHeaderLayout } from '../ensureHeaderLayout';
import {
  MODERNIZED_BLOCK_DIAGRAM_EXPANDER_SIZE as EXPANDER_SIZE,
  MODERNIZED_BLOCK_DIAGRAM_GROUP_PADDING as PADDING,
} from '../consts';
import { MODERNIZED_BLOCK_DIAGRAM_URL_ICON_SIZE as ICON_SIZE } from 'yfilesExtensions/styles/modernized/consts';

/**
 * the top position of the URL icon if there is only one line of text in the group header.
 *
 * this will make the URL vertically center-aligned with the group header label.
 */
const SINGLE_LINE_HEADER_URL_ICON_TOP =
  PADDING + EXPANDER_SIZE / 2 - ICON_SIZE / 2;

class OpenGroupUrlButtonLabelModelParameter extends BaseClass(
  ILabelModelParameter
) {
  #model: OpenGroupUrlButtonLabelModel;
  constructor(model: OpenGroupUrlButtonLabelModel) {
    super();
    this.#model = model;
  }
  override get model(): ILabelModel {
    return this.#model;
  }
  override clone(): this {
    throw new Error('Method not implemented.');
  }
}

class OpenGroupUrlButtonLabelModel extends BaseClass(ILabelModel) {
  constructor(private graph: IGraph) {
    super();
  }
  createParameter(): ILabelModelParameter {
    return new OpenGroupUrlButtonLabelModelParameter(this);
  }
  override getContext(_: ILabel): ILookup {
    return ILookup.EMPTY;
  }
  override getGeometry(
    label: ILabel,
    _: ILabelModelParameter
  ): IOrientedRectangle {
    const { owner } = label;
    if (!(owner instanceof INode)) {
      return IOrientedRectangle.EMPTY;
    }
    const {
      layout: { x: nodeX, y: nodeY, width: nodeWidth },
    } = owner;
    const { tag: graphTag } = this.graph;
    const { groupHeaders } = graphTag as YGraphState;
    const groupHeader = ensureHeaderLayout(owner, groupHeaders);
    if (!groupHeader) {
      return IOrientedRectangle.EMPTY;
    }
    const { wrappedMainLabel } = groupHeader;
    const isSingleLine = wrappedMainLabel.length === 1;

    const x = nodeX + nodeWidth - PADDING - ICON_SIZE;
    const y = isSingleLine
      ? nodeY + SINGLE_LINE_HEADER_URL_ICON_TOP
      : nodeY + PADDING;
    return new OrientedRectangle(new Rect(x, y, ICON_SIZE, ICON_SIZE));
  }
}
export { OpenGroupUrlButtonLabelModel };
